import React, {useEffect, useState} from "react";
import BlueprintImageBlockItem from "./BlueprintImageBlockItem";
import BlueprintImageListItem from "./BlueprintImageListItem";
import BlueprintImageTableItem from "./BlueprintImageTableItem";
import AddBlueprintImageToDataStructureFlowMenu from "./AddBlueprintImageToDataStructureFlowMenu";
import SwitchDisplay from "./SwitchDisplay";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";
import ErrorModal from "./ErrorModal";
import FullScreenLoadingOverlay from "./FullScreenLoadingOverlay";
import AlertPopup from "./AlertPopup";
import I18n from 'i18n.js.erb'
import { IPAD_WIDTH, onKeyDownQuantity } from "../../utils/utils";
import RequiredLoginAlertPopup from "./RequiredLoginAlertPopup.jsx"
import { BLUEPRINT_IMAGES_KEY_FOR_SESSION_STORAGE, DESKTOP_WIDTH, handleBackPage } from "../../utils/utils";
import SuccessFlashMessage from "./SuccessFlashMessage";

const IndexBlueprintImages = ({
  logged_in_user,
  game_id,
  expansion_id,
  game_name,
  versions,
  rarities,
  originalBlueprintImages,
  category_id,
  disable_marketplace
}) => {

  const blueprint_images = JSON.parse(originalBlueprintImages);
  const [ blueprintImages, setBlueprintImages ] = useState([]);
  const [ filterVersions, setFilterVersions ] = useState({
    version: [],
    rarity: [],
    name: ''
  });
  const [ initCompleted, setInitCompleted ] = useState(false)
  const [ selectAll, setSelectAll ] = useState(true);
  const [ submited, setSubmited ] = useState(false);
  const [ orderingNumber, setOrderingNumber ] = useState(1);
  const [ display, setDisplay ] = useState("block");
  const [ openVariantsModal, setOpenVariantsModal ] = useState(false);
  const [ variantsToDisplay, setVariantsToDisplay ] = useState(null);
  const [ globalQuantity, setGlobalQuantity ] = useState(1);
  const [ showSuccessFlashMessage, setShowSuccessFlashMessage ] = useState(false)
  const [successFlashMessage, setSuccessFlashMessage] = useState('')
  const [ showErrorModal, setShowErrorModal ] = useState(false)
  const [ showFullScreenLoadingOverlay, setShowFullScreenLoadingOverlay ] = useState(false)
  const [ showAlertPopupMyCollection, setShowAlertPopupMyCollection ] = useState(false)
  const [ showAlertPopupWishlist, setShowAlertPopupWishlist ] = useState(false)
  const [ loadDataFromSessionStorage, setLoadDataFromSessionStorage  ] = useState(false);
  const [ showRequiredLoginModal, setShowRequiredLoginModal ] = useState(false);

  // console.log("logged_in_user: ", logged_in_user);
  // console.log("game_id: ", game_id);
  // console.log("blueprintImages: ", blueprintImages);

  // Funzione che inizializza lo state enableActionsMenu
  const initializeEnableActionsMenuState = () => {
    if (window.innerWidth < DESKTOP_WIDTH) {
      return false
    } else {
      return true
    }
  }


  const [ enableActionsMenu, setEnableActionsMenu ] = useState(initializeEnableActionsMenuState())

  React.useEffect(function () {
    if (openVariantsModal && getVariantsInsideMatrix().length=== 1) {
      $(".carousel-control-next-icon").css("display","none")
      $(".carousel-control-prev-icon").css("display","none")
    }
  }, [openVariantsModal]);


  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)

      let blueprintImagesPrevData = sessionStorage.getItem(BLUEPRINT_IMAGES_KEY_FOR_SESSION_STORAGE);
      if (blueprintImagesPrevData) {
        blueprintImagesPrevData = JSON.parse(blueprintImagesPrevData);
      }
      let blueprintImagesCurrentUrl = `/games/${game_id}/expansions/${expansion_id}/blueprint_images&language=${blueprint_images[0].language}`;
      let functions = {
        setLoadDataFromSessionStorage: setLoadDataFromSessionStorage,
        setBlueprintImages: setBlueprintImages,
        setFilterVersions: setFilterVersions,
        setSelectAll: setSelectAll,
        setOrderingNumber: setOrderingNumber,
        setDisplay: setDisplay,
        setGlobalQuantity: setGlobalQuantity,
        setEnableActionsMenu: setEnableActionsMenu
      };
      if (blueprintImagesPrevData && blueprintImagesPrevData.url === blueprintImagesCurrentUrl) {
        handleBackPage(BLUEPRINT_IMAGES_KEY_FOR_SESSION_STORAGE, blueprintImagesPrevData, functions);
      } else {
        setBlueprintImages(blueprint_images)
        setFilterVersions([])
      }
    }
  }, []);


  // Funzione che apre un pop up che chiede conferma all'utente circa la sua volontà di inserire nella sua
  // my collection / wishlist le carte che ha selezionato sull'interfaccia grafica
  const openAlertPopup = (popupType) =>{
    if(logged_in_user){
      switch (popupType) {
        case 'wishList':
          setShowAlertPopupWishlist(true)
          break;
        case 'myCollection':
          setShowAlertPopupMyCollection(true)
          break;
      }
    }else{
      setShowRequiredLoginModal(true)
    }
  }


  // Funzione che gestisce la navigazione a una nuova pagina del sito, a partire da quella corrente
  const handleNavigation = (e, blueprintImage, newLocation) => {
    if (e)
      e.preventDefault();

    const blueprintImagesPrevData = {
      url: `/games/${game_id}/expansions/${expansion_id}/blueprint_images&language=${blueprint_images[0].language}`,
      blueprintImages: blueprintImages,
      filterVersions: filterVersions,
      selectAll: selectAll,
      orderingNumber: orderingNumber,
      display: display,
      enableActionsMenu: enableActionsMenu,
      scrollY: window.scrollY
    };
    sessionStorage.setItem(BLUEPRINT_IMAGES_KEY_FOR_SESSION_STORAGE, JSON.stringify(blueprintImagesPrevData));

    window.location = newLocation;
  };


  // Funzione che ritorna l'url dell'immagine della carta che va renderizzata a video
  const blueprintImageMediumImageUrl = (blueprintImage) => {
    const variants = blueprintImage.variants

    if (blueprintImage.medium_image_url)
      return blueprintImage.medium_image_url

    else if (variants && variants.length > 0)
      for (const variant of variants) {
        if (variant.medium_image_url)
          return variant.medium_image_url
      }

    return null
  }


  // Funzione che permette all'utente di aggiungere le carte
  // selezionate sull'interfaccia grafica alla sua My Collection
  const addCardsToMyCollectionHandler = () => {
    if (
      logged_in_user &&
      atLeastOneSelectedCard()
    ) {
      const myCollection = [];
      let globalQuantities = 0
      blueprintImages.forEach((blueprintImage) => {
        if (blueprintImage.checked === true && checkFilters(blueprintImage)) {
          globalQuantities = globalQuantities + (blueprintImage.quantity ? blueprintImage.quantity : "1")
          myCollection.push({
            id: blueprintImage.id,
            blueprint_id: blueprintImage.blueprint_id,
            language: blueprintImage.language,
            quantity: blueprintImage.quantity ? blueprintImage.quantity : "1"
          });
        }

        if (blueprintImage.variants && blueprintImage.variants.length > 0) {
          blueprintImage.variants.forEach((variant) => {
            if (variant.checked === true && checkFilters(variant)) {
              globalQuantities = globalQuantities + (blueprintImage.quantity ? blueprintImage.quantity : "1")
              myCollection.push({
                id: variant.id,
                blueprint_id: variant.blueprint_id,
                language: variant.language,
                quantity: variant.quantity ? variant.quantity : "1"
              });
            }
          });
        }
      });

      setSubmited(true);
      // chiudo il menù delle azioni se sono su mobile
      if (window.innerWidth < DESKTOP_WIDTH) {
        setEnableActionsMenu(false)
      }
      if (globalQuantities > 30)
        setShowFullScreenLoadingOverlay(true)

      const url = "/my_collections";

      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({game_id: game_id, items: myCollection}),
      })
        .then((res) => {
          setSubmited(false)
          setShowFullScreenLoadingOverlay(false)
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json();
        })
        .then((data) => {
          window.location = `/users/${data.user_id}/certificates?game_id=${data.game_id}`;
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  };


  // Funzione che permette all'utente di navigare alla pagina che renderizza tutte le offerte dei prodotti in vendita
  // relativamente alle carte da lui selezionate sull'interfaccia grafica
  const viewOffersHandler = () => {
    if (atLeastOneSelectedCard()) {
      const blueprintImagesIds = [];

      blueprintImages.forEach((blueprintImage) => {
        if (blueprintImage.checked === true && checkFilters(blueprintImage))
          blueprintImagesIds.push(blueprintImage.id);

        if (blueprintImage.variants && blueprintImage.variants.length > 0) {
          blueprintImage.variants.forEach((variant) => {
            if (variant.checked === true && checkFilters(variant))
              blueprintImagesIds.push(variant.id);
          });
        }
      });

      if (blueprintImagesIds.length === 1)
        window.location = `/products/${blueprintImagesIds[0]}`
      else if (blueprintImagesIds.length > 1)
        window.location = `/products?blueprint_images_ids=${blueprintImagesIds}`
    } else {
      window.location = `/products?expansion_id=${expansion_id}&category_id=${category_id}&language=${blueprint_images[0]?.language}`
    }
  };


  // Funzione che permette all'utente di aggiungere le carte
  // selezionate sull'interfaccia grafica alla sua Wishlist
  const addCardsToWishlistHandler = () => {
    if (
      logged_in_user &&
      atLeastOneSelectedCard()
    ) {
      const wishList = [];
      blueprintImages.forEach((blueprintImage) => {
        if (blueprintImage.checked === true && checkFilters(blueprintImage))
          wishList.push(blueprintImage.id);

        if (blueprintImage.variants && blueprintImage.variants.length > 0) {
          blueprintImage.variants.forEach((variant) => {
            if (variant.checked === true && checkFilters(variant))
              wishList.push(variant.id);
          });
        }
      });

      setSubmited(true)
      // chiudo il menù delle azioni se sono su mobile
      if (window.innerWidth < DESKTOP_WIDTH) {
        setEnableActionsMenu(false)
      }
      if (wishList.length > 35)
        setShowFullScreenLoadingOverlay(true)

      const url = "/wishlists";

      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({items: wishList}),
      })
        .then((res) => {
          setSubmited(false)
          setShowFullScreenLoadingOverlay(false)
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json();
        })
        .then((data) => {
          let newBlueprintImages = blueprintImages.map((blueprintImage) => {
            let newVariants = blueprintImage.variants.map((variant) => {
              const newVariant = {
                ...variant,
                checked: false,
              };
              if (variant.checked === true && checkFilters(variant))
                newVariant["already_in_wishlist"] = data.id;
              return newVariant;
            });

            const newBlueprintImage = {
              ...blueprintImage,
              checked: false,
              variants: newVariants,
            };
            if (blueprintImage.checked === true && checkFilters(blueprintImage))
              newBlueprintImage["already_in_wishlist"] = data.id;
            return newBlueprintImage;
          });
          setBlueprintImages(newBlueprintImages);
          setSelectAll(true);
          setShowSuccessFlashMessage(true)
          setSuccessFlashMessage(wishList.length === 1 ? I18n.t('js.indexCardPage.productAddedToWishlist') : I18n.t('js.indexCardPage.productsAddedToWishlist'))
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  };


  // Funzione che permette di gestire la selezione di una nuova carta da aggiungere
  // alla my collection / wishlist dell'utente
  const onCheckHandler = (e) => {
    let newBlueprintImages;
    if (!openVariantsModal) {
      newBlueprintImages = blueprintImages.map((blueprintImage) => {
        if (blueprintImage.id === Number.parseInt(e.target.id, 10)) {
          setOrderingNumber(orderingNumber + 1);
          return {
            ...blueprintImage,
            checked: blueprintImage.encasing_id ? (blueprintImage.checked !== true) : false,
            ordering_number: orderingNumber,
          };
        }
        return blueprintImage;
      });
      setBlueprintImages(newBlueprintImages);
    } else {
      newBlueprintImages = blueprintImages.map((blueprintImage) => {
        if (blueprintImage.id === Number.parseInt(e.target.id, 10)) {
          setOrderingNumber(orderingNumber + 1);
          const selectedBlueprintImage = {
            ...blueprintImage,
            checked: blueprintImage.encasing_id ? (blueprintImage.checked !== true) : false,
            ordering_number: orderingNumber,
          };
          setVariantsToDisplay(
            [selectedBlueprintImage].concat(selectedBlueprintImage.variants)
          );
          return selectedBlueprintImage;
        } else if (
          blueprintImage.variants &&
          blueprintImage.variants.length > 0
        ) {
          let found = false;
          let newVariants = blueprintImage.variants.map((variant) => {
            if (variant.id === Number.parseInt(e.target.id, 10)) {
              found = true;
              setOrderingNumber(orderingNumber + 1);
              return {
                ...variant,
                checked: variant.encasing_id ? (variant.checked !== true) : false,
                ordering_number: orderingNumber,
              };
            }
            return variant;
          });
          if (found) {
            setVariantsToDisplay([blueprintImage].concat(newVariants));
          }
          return {
            ...blueprintImage,
            variants: newVariants,
          };
        }
        return blueprintImage;
      });
      setBlueprintImages(newBlueprintImages);
    }

    if (allSelectedCards(filterVersions, newBlueprintImages)) {
      setSelectAll(false)
    } else {
      setSelectAll(true)
    }
  };


  // Funzione che verifica se tra le carte fitlrate sull'interfaccia grafica, ve n'è almeno una selezionata dall'utente
  function atLeastOneSelectedCard() {
    for (const blueprintImage of blueprintImages) {
      if (blueprintImage.checked && checkFilters(blueprintImage))
        return true;
      if (blueprintImage.variants && blueprintImage.variants.length > 0) {
        for (const variant of blueprintImage.variants) {
          if (variant.checked && checkFilters(variant))
            return true;
        }
      }
    }
    return false;
  }


  // Funzione che verifica le carte filtrate sull'interfaccia grafica siano tutte selezionate dall'utente
  function allSelectedCards(newFilterVersions, newBlueprintImages) {
    for (const blueprintImage of newBlueprintImages) {
      if (!newFilterVersions.version || newFilterVersions.version.length === 0 || newFilterVersions.version.includes(blueprintImage.version))
        if (!blueprintImage.checked)
          return false;
      if (blueprintImage.variants && blueprintImage.variants.length > 0) {
        for (const variant of blueprintImage.variants) {
          if (!newFilterVersions.version || newFilterVersions.version.length === 0 || newFilterVersions.version.includes(variant.version))
            if (!variant.checked)
              return false;
        }
      }
    }
    return true;
  }

  // Funzione che restituisce true se la blueprintImage passata in input fa match con
  // i filtri di ricerca impostati, false altrimenti
  const checkFilters = (blueprintImage) => {
    let output = true;

    if (filterVersions.version && filterVersions.version.length > 0) {
      if (!filterVersions.version.includes(blueprintImage.version)) {
        output = false;
      }
    }

    if (filterVersions.name && filterVersions.name.length > 0) {
      if ((!blueprintImage.en_name || !blueprintImage.en_name.toLowerCase().includes(filterVersions.name.trim().toLowerCase())) &&
        (!blueprintImage.meta_name || !blueprintImage.meta_name.toLowerCase().includes(filterVersions.name.trim().toLowerCase()))) {
        output = false;
      }
    }

    if (filterVersions.rarity && filterVersions.rarity.length > 0) {
      if (!filterVersions.rarity.includes(blueprintImage.rarity)) {
        output = false;
      }
    }

    return output;
  }


  // Funzione che permette di selezionare TUTTE le carte dell'espansione in questione per aggiungerle
  // alla my collection / wishlist dell'utente
  const onMultipleSelectHandler = () => {
    setOrderingNumber(orderingNumber + 1);
    let newBlueprintImages = blueprintImages.map((blueprintImage) => {
      if (blueprintImage.variants && blueprintImage.variants.length > 0) {
        let newVariants = blueprintImage.variants.map((variant) => {
          if (checkFilters(variant)) {
            return {
              ...variant,
              checked: variant.encasing_id ? selectAll : false,
              ordering_number: variant["ordering_number"]
                ? variant["ordering_number"]
                : orderingNumber,
            };
          }
          return variant;
        });

        if (checkFilters(blueprintImage)) {
          return {
            ...blueprintImage,
            checked: blueprintImage.encasing_id ? selectAll : false,
            ordering_number: blueprintImage["ordering_number"]
              ? blueprintImage["ordering_number"]
              : orderingNumber,
            variants: newVariants,
          };
        }
        return {
          ...blueprintImage,
          variants: newVariants,
        };
      } else {
        if (checkFilters(blueprintImage)) {
          return {
            ...blueprintImage,
            checked: blueprintImage.encasing_id ? selectAll : false,
            ordering_number: blueprintImage["ordering_number"]
              ? blueprintImage["ordering_number"]
              : orderingNumber,
          };
        }
        return {
          ...blueprintImage
        };
      }
    });
    setBlueprintImages(newBlueprintImages);
    setSelectAll(!selectAll);
  };


  // Funzione che verifica se, tra gli eventuali varianti di una carta, ve n'è almeno uno già selezionato dall'utente
  // per aggiungerlo alla collection / wishlist
  const atLeastOneVariantChecked = (blueprintImage) => {
    if (blueprintImage.variants && blueprintImage.variants.length > 0)
      for (const variant of blueprintImage.variants) {
        if (variant.checked && variant.checked === true) return true;
      }
    return false;
  };

  // Funzione che permette di aggiornare la quantità di copie di una stessa carta che l'utente vuole aggiungere alla
  // sua collection
  const onChangeQuantity = (e, index) => {
    if (e.target.value === '' || e.target.value > 0) {
      const selectedBlueprintImage = openVariantsModal
        ? variantsToDisplay[index]
        : blueprintImages[index];

      let newBlueprintImages = blueprintImages.map((blueprintImage) => {
        if (blueprintImage.id === selectedBlueprintImage.id) {
          const newBlueprintImage = {
            ...blueprintImage,
            quantity: e.target.value,
          };
          if (openVariantsModal)
            setVariantsToDisplay(
              [newBlueprintImage].concat(newBlueprintImage.variants)
            );
          return newBlueprintImage;
        } else if (
          blueprintImage.variants &&
          blueprintImage.variants.length > 0
        ) {
          let found = false;
          let newVariants = blueprintImage.variants.map((variant) => {
            if (variant.id === selectedBlueprintImage.id) {
              found = true;
              return {
                ...variant,
                quantity: e.target.value,
              };
            }
            return variant;
          });
          if (found) {
            setVariantsToDisplay([blueprintImage].concat(newVariants));
          }
          return {
            ...blueprintImage,
            variants: newVariants,
          };
        }
        return blueprintImage;
      });
      setBlueprintImages(newBlueprintImages);
    }
  };

  // Funzione che permette di aggiornare la quantità di copie di tutte le carte selezionate dall'utente da aggiungere
  // alla sua collection
  const onChangeGlobalQuantity = (newQuantity) => {
    if (atLeastOneSelectedCard() && (newQuantity === '' || newQuantity > 0)) {
      let newBlueprintImages = blueprintImages.map((blueprintImage) => {
        const newBlueprintImage = {...blueprintImage}
        newBlueprintImage['quantity'] =
          checkFilters(blueprintImage) && newBlueprintImage.checked ? newQuantity : blueprintImage.quantity

        if (blueprintImage.variants && blueprintImage.variants.length > 0) {
          newBlueprintImage['variants'] = blueprintImage.variants.map((variant) => {
            if (checkFilters(variant) && variant.checked) {
              return {
                ...variant,
                quantity: newQuantity,
              };
            }
            return variant;
          });
        }

        return newBlueprintImage
      });

      setGlobalQuantity(newQuantity)
      setBlueprintImages(newBlueprintImages);
    }else if(!logged_in_user){
      setShowRequiredLoginModal(true)
    }
  };

  // Funzione che permette di renderizzare sull'interfaccia grafica la finestra con tutti i varianti in cui è
  // disponibile una certa carta
  const displayVariantsHandler = (e, index) => {
    if (!openVariantsModal) {
      const blueprintImage = blueprintImages[index];

      if (blueprintImage.variants.length > 0) {
        setVariantsToDisplay([blueprintImage].concat(blueprintImage.variants));
        setOpenVariantsModal(true);
        e.preventDefault();
      }
    }
  };

  // Funzione che filtra le carte presenti sull'interfaccia grafica in base alla loro versione
  const setVersionFilter = (e) => {
    // faccio una deep copy dell'oggetto filterVersions
    let newFilterVersions = {...filterVersions};
    let idx;

    if (e.target.id.includes('version_')) {
      if (!newFilterVersions.version) {
        newFilterVersions.version = [];
      }

      let version = e.target.id.replace('version_', '');

      if (!newFilterVersions.version.includes(version)) {
        newFilterVersions.version.push(version);
      } else {
        idx = newFilterVersions.version.indexOf(version);
        newFilterVersions.version.splice(idx, 1);
      }
    } else if ("card_name" === e.target.id) {
      newFilterVersions.name = e.target.value;
    } else if (e.target.id.includes('rarity_')) {
      if (!newFilterVersions.rarity) {
        newFilterVersions.rarity = [];
      }

      let rarity = e.target.id.replace('rarity_', '');

      if (e.target.checked) {
        newFilterVersions.rarity.push(rarity);
      } else {
        idx = newFilterVersions.rarity.indexOf(rarity);
        newFilterVersions.rarity.splice(idx, 1);
      }
    }

    setFilterVersions(newFilterVersions);

    if (allSelectedCards(newFilterVersions, blueprintImages)) {
      setSelectAll(false)
    } else {
      setSelectAll(true)
    }
  };

  //Funzione che setta il nuovo filtro di ricerca per nome
  const onChangeFilterNameHandler = (newFilterName) => {
    const newFilters = { ...filters }
    newFilters.name = newFilterName;
    setFilters(newFilters);
  }


  // Funzione che permette di cambiare la modalità di visualizzazione delle carte da griglia a lista o viceversa
  const switchTab = (e) => {
    e.stopPropagation()
    if (e.target.id === "button-list") {
      setDisplay("list");
    } else if (e.target.id === "button-block") {
      setDisplay("block");
    } else {
      setDisplay("table");
    }
  };

  //converte l'array di VariantsToDisplay in una matrice con
  // coppie di elementi [[1,2] [3,4]... [n-1,n]]
  const getVariantsInsideMatrix = () => {
    let matrix = [], i, k;
    for (i = 0, k = -1; i < variantsToDisplay.length; i++) {
      if (i % 2 === 0) {
        k++;
        matrix[k] = [];
      }
      matrix[k].push(variantsToDisplay[i]);
    }
    return matrix;
  }

  const isAtLeastOneBlueprintImageVisible = (blueprintImages) => {
    let counter = 0;
    blueprintImages.map((blueprintImage) => {
      if (checkFilters(blueprintImage)) {
        counter++;
      }
    });
    return counter > 0;
  }



  return (
    <React.Fragment>
      <AddBlueprintImageToDataStructureFlowMenu
        logged_in_user={logged_in_user}
        onMultipleSelectHandler={onMultipleSelectHandler}
        selectAll={selectAll}
        submited={submited}
        alertPopupHandler={openAlertPopup}
        viewOffersHandler={viewOffersHandler}
        filterVersions={filterVersions}
        setVersionFilter={setVersionFilter}
        onChangeFilterNameHandler={onChangeFilterNameHandler}
        versions={versions}
        rarities={rarities}
        atLeastOnSelectedCard={atLeastOneSelectedCard()}
        globalQuantity={globalQuantity}
        onKeyDownQuantity={onKeyDownQuantity}
        onChangeGlobalQuantity={onChangeGlobalQuantity}
        isEnableAction={enableActionsMenu}
        setEnabledActions={setEnableActionsMenu}
        disable_marketplace={disable_marketplace}
      />

      <div className="switch-display-container">
        <SwitchDisplay switchTab={switchTab}
                       listTabColor={`${display == 'list' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`}
                       blockTabColor={`${display == 'block' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`}
                       tableTabColor={`${display === 'table' ? 'icon--color-active icon--bg-active' : 'icon--color-standard'}`}
                       tableLayoutOnlyFor={'show-on-desktop-imp'}
        />
      </div>

      <h1
        className={`${(versions.length > 1 || enableActionsMenu) ? 'mt-130px' : 'mt-30px'} text-center text-night-blue text-space font-weight-bold show-on-tablet`}>
        {I18n.t('js.indexCardPage.selectYourCards')}
      </h1>


      <div id="elements-container container" className={`${window.innerWidth>IPAD_WIDTH ? 'ml-300px mr-50px' : 'mr-1 mr-md-3 ml-1 ml-md-3'} ${window.innerWidth>=IPAD_WIDTH ? 'mt-130px' : 'mt-10px'} ${display === 'block' ? 'border-aiG-black-imp' : ''}`}>
        {display === "list" &&
          <div
            className={`mt-40px-imp table-responsive ${isAtLeastOneBlueprintImageVisible(blueprintImages) === false && 'd-none'} ${window.innerWidth > IPAD_WIDTH ? 'w-95' : 'w-100'}`}>

            <table id="order-edit"
                   className="table table-hover mt-10px bg-white">
              <thead className="thead-dark">
              <tr>
                <th className="text-center minW-150px">{I18n.t('js.indexCardPage.tableLayout.tableHeaderImage')}</th>
                <th className="text-center">{I18n.t('js.indexCardPage.tableLayout.tableHeaderName')}</th>
                <th className="text-center minW-150px">{I18n.t('js.indexCardPage.tableLayout.tableHeaderRarity')}</th>
                <th
                  className="text-center max-w-250px-imp">{I18n.t('js.indexCardPage.tableLayout.tableHeaderQuantity')}</th>
                <th className="text-center">{I18n.t('js.indexCardPage.tableLayout.tableHeaderdetail')}</th>
                <th className="text-center"></th>
                <th className="text-center"></th>
              </tr>
              </thead>
              <tbody>
              {blueprintImages.map((blueprintImage, i) => (
                <BlueprintImageListItem
                  key={blueprintImage.id}
                  logged_in_user={logged_in_user}
                  blueprintImage={blueprintImage}
                  checkFilters={checkFilters}
                  onCheckHandler={onCheckHandler}
                  onChangeQuantity={onChangeQuantity}
                  onKeyDownQuantity={onKeyDownQuantity}
                  displayVariantsHandler={displayVariantsHandler}
                  modalOpened={false}
                  atLeastOneVariantChecked={atLeastOneVariantChecked}
                  handleNavigation={handleNavigation}
                  gameName={game_name}
                  i={i}
                  blueprintImageMediumImageUrl={blueprintImageMediumImageUrl}
                />
              ))}
              </tbody>
            </table>
          </div>

        }

        {display === "block" &&
            <div
              className={`row m-auto bg-white pt-20px ${isAtLeastOneBlueprintImageVisible(blueprintImages) === false && 'd-none'}`}>
              {blueprintImages.map((blueprintImage, i) => (
                <BlueprintImageBlockItem
                  key={blueprintImage.id}
                  blueprintImage={blueprintImage}
                  checkFilters={checkFilters}
                  onCheckHandler={onCheckHandler}
                  onChangeQuantity={onChangeQuantity}
                  onKeyDownQuantity={onKeyDownQuantity}
                  displayVariantsHandler={displayVariantsHandler}
                  modalOpened={false}
                  atLeastOneVariantChecked={atLeastOneVariantChecked}
                  handleNavigation={handleNavigation}
                  gameName={game_name}
                  i={i}
                  blueprintImageMediumImageUrl={blueprintImageMediumImageUrl}
                />
              ))}
            </div>
        }

        {
          display === "table" &&
          <div
            className={`mt-40px-imp table-responsive ${isAtLeastOneBlueprintImageVisible(blueprintImages) === false && 'd-none'} ${window.innerWidth > IPAD_WIDTH ? 'w-95' : 'w-100'}`}>

            <table id="order-edit"
                   className="table table-hover mt-10px bg-white">
              <thead className="thead-dark">
              <tr>
                <th className="text-center">{I18n.t('js.indexCardPage.tableLayout.tableHeaderImage')}</th>
                <th className="text-center">{I18n.t('js.indexCardPage.tableLayout.tableHeaderName')}</th>
                <th className="text-center" />
                <th className="text-center minW-150px">{I18n.t('js.indexCardPage.tableLayout.tableHeaderRarity')}</th>
                <th className="text-center minW-150px">{I18n.t('js.indexCardPage.tableLayout.tableHeaderVersion')}</th>
                <th
                  className="text-center max-w-250px-imp">{I18n.t('js.indexCardPage.tableLayout.tableHeaderQuantity')}</th>
                <th className="text-center">{I18n.t('js.indexCardPage.tableLayout.tableHeaderdetail')}</th>
                <th className="text-center" />
                <th className="text-center" />
              </tr>
              </thead>
              <tbody>
              {blueprintImages.map((blueprintImage, i) => (
                <BlueprintImageTableItem
                  key={blueprintImage.id}
                  logged_in_user={logged_in_user}
                  blueprintImage={blueprintImage}
                  checkFilters={checkFilters}
                  onCheckHandler={onCheckHandler}
                  onChangeQuantity={onChangeQuantity}
                  onKeyDownQuantity={onKeyDownQuantity}
                  displayVariantsHandler={displayVariantsHandler}
                  modalOpened={false}
                  atLeastOneVariantChecked={atLeastOneVariantChecked}
                  handleNavigation={handleNavigation}
                  gameName={game_name}
                  i={i}
                  blueprintImageMediumImageUrl={blueprintImageMediumImageUrl}
                />
              ))}
              </tbody>
            </table>
          </div>

        }

        {
          isAtLeastOneBlueprintImageVisible(blueprintImages) === false &&
            <div className="d-flex justify-content-center mt-2 pt-3">
              <div className="d-flex align-items-center text-muted">
                <p
                  className="text-space text-black-50 text--size-normal text-center text-bold">{I18n.t('js.filters.noResultsFound')}</p>
              </div>
            </div>
        }

      </div>

      <Modal
        size="lg"
        show={openVariantsModal}
        onHide={() => setOpenVariantsModal(false)}
        animation={false}
      >
        <Modal.Header>
          <h2 className="text-center">{I18n.t('js.indexCardPage.selectTheCard')}</h2>
        </Modal.Header>
        <Modal.Body className="row p-0 d-flex justify-content-center">

          <div className="col-12 mt-10px show-on-desktop-d-block">
            <Carousel className="w-100">
              {variantsToDisplay && (
                getVariantsInsideMatrix().map((row, i) => (
                    <Carousel.Item key={'carousel_'+ i } interval={100000}>
                      <div className="d-flex justify-content-center">
                        {row.map((blueprintImage, k) => (
                          <div  key={blueprintImage.id} className="col-lg-4">
                            <BlueprintImageBlockItem
                              blueprintImage={blueprintImage}
                              checkFilters={checkFilters}
                              onCheckHandler={onCheckHandler}
                              onChangeQuantity={onChangeQuantity}
                              onKeyDownQuantity={onKeyDownQuantity}
                              displayVariantsHandler={displayVariantsHandler}
                              modalOpened={true}
                              atLeastOneVariantChecked={atLeastOneVariantChecked}
                              handleNavigation={handleNavigation}
                              gameName={game_name}
                              // i è l'indice che identifica ogni carta univocamente.
                              // La matrice utilizzata per mappare i dati è Nx2 quindi
                              // ogni sua riga sarà formata da 2 colonne.
                              // Poichè i deve essere univoco e il ciclo sulla matrice non
                              // mi permette di avere un i univoco per ogni carta, con la
                              // formula 2*i+k posso risalire a quale era l'indice della carta esaminata
                              // all'interno dell'array variantsToDisplay ed avere così un indice univoco
                              // per ognuna.
                              i={2*i+k}
                            />
                          </div>
                        ))}
                      </div>
                    </Carousel.Item>
                  )
                )
              )}
            </Carousel>
          </div>


          <div className="col-12 mt-10px show-on-mobile">
            <Carousel className="w-100">
              {variantsToDisplay && (
                variantsToDisplay.map((blueprintImage, i) => (
                  <Carousel.Item key={blueprintImage.id} interval={100000}>
                    <div className="d-flex justify-content-center">
                      <div className="col-xs-12 col-md-6">
                        <BlueprintImageBlockItem
                          key={blueprintImage.id}
                          blueprintImage={blueprintImage}
                          checkFilters={checkFilters}
                          onCheckHandler={onCheckHandler}
                          onChangeQuantity={onChangeQuantity}
                          onKeyDownQuantity={onKeyDownQuantity}
                          displayVariantsHandler={displayVariantsHandler}
                          modalOpened={true}
                          atLeastOneVariantChecked={atLeastOneVariantChecked}
                          handleNavigation={handleNavigation}
                          gameName={game_name}
                          i={i}
                        />
                      </div>
                    </div>

                  </Carousel.Item>
                ))
              )}
            </Carousel>
          </div>
          
          <div className="col-12 text-right ">
            <button
              className="btn-standard bg-aig-gradient text-light br-20px btn-standard-resized p-5px-imp text--size-normal-imp w-25 mr-10px mb-10px"
              type="button"
              onClick={() => setOpenVariantsModal(false)}>
              {I18n.t('js.common.ok').toUpperCase()}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <SuccessFlashMessage
        showSuccessFlashMessage={showSuccessFlashMessage}
        setShowSuccessFlashMessage={setShowSuccessFlashMessage}
        successMessage={successFlashMessage}
      />

      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
      />

      <FullScreenLoadingOverlay
        showFullScreenLoadingOverlay={showFullScreenLoadingOverlay}
        textFullScreenLoadingOverlay={`${I18n.t('js.indexCardPage.addingCardSpinner')}`}
      />


      {/*Alert per add in My collection*/}
      <AlertPopup
        showAlertPopup={showAlertPopupMyCollection}
        onSuccess={addCardsToMyCollectionHandler}
        onDiscard={setShowAlertPopupMyCollection}
        popupTitle={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyCollectionTitle')}`}
        popupContent={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMycollectionContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirmAdd').toUpperCase()}`}
      />

      {/*Alert per add in My wishlist*/}
      <AlertPopup
        showAlertPopup={showAlertPopupWishlist}
        onSuccess={addCardsToWishlistHandler}
        onDiscard={setShowAlertPopupWishlist}
        popupTitle={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyWishlistTitle')}`}
        popupContent={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyWishlistContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirmAdd').toUpperCase()}`}
      />

      <RequiredLoginAlertPopup
        showRequiredLoginAlertPopup={showRequiredLoginModal}
        onClose={setShowRequiredLoginModal}
      />

    </React.Fragment>
  );
};

export default IndexBlueprintImages;